import "./DisplayInfo.scss";

export default function DisplayInfo({ variant, message }) {
  return (
    <div id="display-info">
      <div className={`message ${variant}`}>
        <p>{message}</p>
      </div>
    </div>
  );
}
